import React, { useEffect, useState } from "react"
import { useHistory } from 'react-router-dom';
import { AdminIcon, AdminIcons } from "../Shared/AdminIcon";
import { ThreeColumnContainer, TwoColumnContainer } from "../Shared/Formelements";
import { ScreenHeader } from "../UI/Elements";
import { FetchHandler } from "../../Handlers/FetchHandler";
import { useUsers } from "../../hooks/useUsers";
import { Dialog } from "../Shared/Dialog";
import { useOrganizations, useOrganizationsApi } from "./useOrganizations";
import { DateFormatter, StringHelper } from "../../Handlers/Helpers";
import { Routes } from "../../Handlers/ViewHandler";
import { OrganizationModelType, OrganizationUsersModelType } from "../../rdx/organizationReducer";
import { AccountType } from "../../hooks/useAccountsAdmin";
import { MessageBoxes } from "../../Handlers/MessageBoxes";
import { useDateHelper } from "../../hooks/useHelper";
import { usePricing } from "../../hooks/usePricing";

export const Organizations = () => {


    const history = useHistory();
    const helper = useDateHelper();



    const ui = useOrganizations();
    useEffect(() => {
        ui.doSearch("")
    }, []);


    const [showAdd, setShowAdd] = useState<boolean>(false);
    const [viewState, setViewState] = useState<"view" | "adding" | "editing">("view");


    const pricing = usePricing();


    return (
        <div className="screen-organizations">
            <ScreenHeader text="Organisationer" icon={AdminIcons.house} />
            <div>
                <div className="filter-tools">
                    <div className="flex0">
                        <label>Sök</label>
                        <input
                            placeholder="Sök..."
                            className="frm" type={"search"}
                            value={ui.search}
                            onChange={e => ui.setSearch(e.target.value)}
                            onKeyUp={e => {
                                if (e.key === "Enter") {
                                    ui.doSearch(e.currentTarget.value);
                                }
                            }}
                        />
                    </div>
                    <div className="flex0">
                        <button
                            className={"btn" + (ui.filter.onlyBilling ? " btn-toggle-down" : "")}
                            onClick={() => {
                                ui.setFilter({ ...ui.filter, onlyBilling: !ui.filter.onlyBilling })
                            }}>
                            <AdminIcon icon={!ui.filter.onlyBilling ? AdminIcons.checkbox_unchecked : AdminIcons.checkbox_checked} />
                            &nbsp;
                            Enbart fakturerbara
                        </button>
                    </div>
                    <div className="flex0">
                        <button
                            className={"btn" + (ui.filter.removeTest ? "" : " btn-toggle-down")}
                            onClick={() => {
                                ui.setFilter({ ...ui.filter, removeTest: !ui.filter.removeTest })
                            }}>
                            <AdminIcon icon={!ui.filter.removeTest ? AdminIcons.checkbox_checked : AdminIcons.checkbox_unchecked} />
                            &nbsp;
                            Visa test
                        </button>
                    </div>

                    <div className="flex1"></div>
                    <div className="flex0">
                        <button className="btn" onClick={() => {
                            setShowAdd(true);
                            ui.setModel({} as OrganizationModelType);
                            setViewState("adding");
                        }}>
                            <AdminIcon icon={AdminIcons.plus} />
                            &nbsp;Lägg till
                        </button>
                    </div>
                </div>
            </div>
            <hr />
            <div>
                <table className="tbl tbl-small">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Namn</th>
                            <th>OrgNr</th>
                            <th>Kundnr</th>
                            <th>Adress</th>
                            {/* <th>Email</th> */}
                            <th>Karta</th>
                            <th>Skapad</th>
                            <th>Konto</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {ui.filterdData.map(n => {
                            const at = ui.getAccountType(n?.id);

                            return (
                                <tr key={n?.id} data-id={n?.id} className={"account-type-" + at}>
                                    <td>
                                        {n?.istestorganization && (<AdminIcon icon={AdminIcons.flask} />)}
                                        {n?.billing && (<AdminIcon icon={AdminIcons.dollarsign} />)}
                                    </td>
                                    <td>{n?.name}</td>
                                    <td>{n?.organizationnumber}</td>
                                    <td>{!!n?.billingcustomernumber ? n?.billingcustomernumber : "-"} {!!n?.billingcurrency && (<span>({n?.billingcurrency})</span>)} </td>
                                    <td>{n?.postaladdress}</td>
                                    {/* <td>{n?.billingemail}</td> */}
                                    <td>{n?.showonmap ? "X" : ""}</td>
                                    <td>{helper.epochToDateTime(n?.sys_datecreated_utc_epoch)}</td>
                                    {/* <td>{ui.getUser(n?.organizationowneruserid)?.name}</td> */}
                                    <td>{at === "premium" ? "Premium" : at == "trial" ? "Trial" : "Basic"}</td>
                                    <td>
                                        <div className="pull-right">

                                            <button className="btn" onClick={() => {
                                                setShowAdd(true);
                                                ui.setModel(n);
                                                setViewState("editing");
                                            }}>
                                                <AdminIcon icon={AdminIcons.pen} />
                                                &nbsp;Ändra
                                            </button>


                                            <button className="btn" onClick={() => history.push(Routes.getOrganizationsUsers(n?.id))}>
                                                <AdminIcon icon={AdminIcons.users} />
                                                &nbsp;Användare
                                            </button>

                                            <button className="btn" onClick={() => history.push(Routes.getOrganizationsSettings(n?.id))}>
                                                <AdminIcon icon={AdminIcons.cog} />
                                                &nbsp;Inställningar
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <Dialog
                title={viewState === "adding" ? "Lägg till organisation" : "Ändra organisation"}
                visible={showAdd}
                onOk={async () => {
                    if (viewState === "editing") {
                        await ui.onUpdate(ui.model)
                    } else if (viewState === "adding") {
                        await ui.onAdd(ui.model)
                    }
                    ui.setModel({} as OrganizationModelType);
                    setShowAdd(false);
                    setViewState("view");

                }}
                okDisabled={!ui.isModelValid}
                okButtonText={viewState === "adding" ? "Lägg till" : "Ändra"}
                cancelButtonText="Ångra"
                onCancel={() => {
                    ui.setModel({} as OrganizationModelType);
                    setShowAdd(false);
                    setViewState("view");

                }}
                width="1200px"
            >
                <div>

                    <ThreeColumnContainer>
                        <div>
                            <InputWithLabel label="Namn" value={ui.model.name} onChange={e => ui.setModel({ ...ui.model, name: e })} />
                            <InputWithLabel label="weburl" value={ui.model.weburl} onChange={e => ui.setModel({ ...ui.model, weburl: e })} />
                            <InputWithLabel label="Adress" value={ui.model.address} onChange={e => ui.setModel({ ...ui.model, address: e })} />
                            <InputWithLabel label="Postnummer & ort" value={ui.model.postaladdress} onChange={e => ui.setModel({ ...ui.model, postaladdress: e })} />
                            <hr />
                            <div>
                                Från pro web:
                            </div>
                            <FromWeb label="Profilnamn" value={ui.model?.customercontactname} />
                            <FromWeb label="Besöksadress" value={ui.model?.customercontactaddress} />
                            <FromWeb label="Telefon" value={ui.model?.customercontactphone} />
                            <FromWeb label="E-post" value={ui.model?.customercontactemail} />
                            <FromWeb label="Hemsida" value={ui.model?.customercontactweb} />
                            <FromWeb label="Facebook" value={ui.model?.customercontactfacebook} />
                            <FromWeb label="Instagram" value={ui.model?.customercontactinstagram} />
                        </div>
                        <div>
                            <InputWithLabel label="Organisationsnummer" value={ui.model.organizationnumber} onChange={e => ui.setModel({ ...ui.model, organizationnumber: e })} />
                            <InputWithLabel label="fakturerings E-Post" value={ui.model.billingemail} onChange={e => ui.setModel({ ...ui.model, billingemail: e })} />
                            <InputWithLabel label="Kontaktnamn" value={ui.model.contact} onChange={e => ui.setModel({ ...ui.model, contact: e })} />
                            <InputWithLabel label="Externt kundnummer" value={ui.model.billingcustomernumber} onChange={e => ui.setModel({ ...ui.model, billingcustomernumber: e })} />
                            <InputWithLabel label="Rabatt" value={ui.model.billingdiscount} onChange={e => ui.setModel({ ...ui.model, billingdiscount: e })} />
                            <InputWithLabel label="Fatureringsinfo" value={ui.model.billingnotes} onChange={e => ui.setModel({ ...ui.model, billingnotes: e })} />
                            <CheckBoxWithLabel label="Ska faktureras" value={ui.model.billing} onChange={e => ui.setModel({ ...ui.model, billing: e })} />
                            <div>
                                <div>
                                    <label>Valuta</label>
                                </div>
                                <select className="frm" onChange={e => ui.setModel({ ...ui.model, billingcurrency: e.target.value })} value={ui.model.billingcurrency}>
                                    <option value={"-"}>-</option>
                                    {pricing.allCurrencies.map(c => (
                                        <option key={c.currency} value={c.currency}>
                                            {c.currency} ({c.short})
                                        </option>
                                    ))}
                                </select>
                            </div>

                        </div>
                        <div>
                            <TextAreaWithLabel
                                label="Beskrivning"
                                value={ui.model.description}
                                onChange={e => ui.setModel({ ...ui.model, description: e })}
                                height="281px"
                            />
                            {viewState === "editing" && (
                                <TextWithLabel label="Ägare" value={ui.getUser(ui.model?.organizationowneruserid)?.name ?? ui.getUser(ui.model?.organizationowneruserid)?.email} />
                            )}
                            {viewState === "adding" && (
                                <SingleUserEditor label="Ägare" userId={ui.model?.organizationowneruserid} onChange={(e: string) => ui.setModel({ ...ui.model, organizationowneruserid: e })} />
                            )}

                        </div>

                    </ThreeColumnContainer>
                </div>
            </Dialog>
        </div>
    )
}

const FromWeb = ({ label, value }: { label: string, value: string }) => {
    if (!value) { return (null) }
    return (
        <div className="from-web">
            <span className="bold">{label}: </span>
            {value}
        </div>
    )
}

const InputWithLabel = ({ label, value, onChange }: { label: string, value: string, onChange(e: string): void }) => {
    return (

        <div>
            <label>{label}</label>
            <div>
                <input type="text" className="frm" value={value} onChange={e => onChange(e.target.value)} />
            </div>
        </div>
    )
}
const CheckBoxWithLabel = ({ label, value, onChange }: { label: string, value: boolean, onChange(e: boolean): void }) => {
    return (

        <div>
            <label>{label}</label>
            <div>
                <input type="checkbox" className="frm" checked={value} onChange={e => onChange(e.target.checked)} style={{ width: "20px" }} />
            </div>
        </div>
    )
}
const TextAreaWithLabel = ({ label, value, onChange, height }: { label: string, value: string, onChange(e: string): void, height?: string }) => {
    return (

        <div>
            <label>{label}</label>
            <div>
                <textarea
                    className="frm"
                    value={value}
                    onChange={e => onChange(e.target.value)}
                    style={{ height: !!height ? height : "" }}
                ></textarea>
            </div>
        </div>
    )
}
const TextWithLabel = ({ label, value }: { label: string, value: string, }) => {
    return (

        <div className="text-with-label">
            <label>{label}</label>
            <div>
                <div className="value">
                    {value}
                </div>
            </div>
        </div>
    )
}

const SingleUserEditor = ({ label, userId, onChange }: { label: string, userId: string, onChange(e: string): void }) => {

    const users = useUsers();
    const api = useOrganizationsApi()
    const [currentUserID, setCurrentUserID] = useState<string>(userId);
    const [currentSearch, setCurrentSearch] = useState<string>("");
    useEffect(() => { setCurrentUserID(userId) }, [, userId]);

    const [viewState, setViewState] = useState<"view" | "edit">("view");

    useEffect(() => {
        if (currentUserID?.length > 0 || userId?.length > 0) {
            users.ensureUserInfo([currentUserID, userId]);
        }
    }, [currentUserID, userId]);


    const [isSearching, setIsSearching] = useState<boolean>(false);
    const [searchHits, setSearchHits] = useState<AccountType[]>([])
    const onSearch = async (e: string) => {
        setIsSearching(true);
        const url = "/api/accounts?page=0&pagesize=15&sort=created&search=" + encodeURI(e);
        const us: AccountType[] = await FetchHandler.getJson(url);
        setSearchHits(us);

        if (us?.length === 1) {
            setCurrentUserID(us[0]?.id)
        } else if (us?.length > 1) {
            MessageBoxes.info("Du fick fler än 1 träff, ange en tydligare sökning")
        } else {
            MessageBoxes.info("Du fick inga träffar")
        }

        setIsSearching(false);
    };

    return (
        <div className="singleusereditor">

            <label>{label}</label>

            {(viewState === "view" || viewState === "edit") && (
                <div className="singleusereditor-edit">
                    <div className="name">
                        <span>
                            {users?.getUsersName(currentUserID) || "N/A"}
                        </span>
                    </div>
                    <div className="singleusereditor-btn">
                        <button className="btn" onClick={() => setViewState("edit")} >
                            <AdminIcon icon={AdminIcons.pen} />
                        </button>
                    </div>
                </div>
            )}

            {viewState === "edit" && (
                <div className="singleusereditor-edit">
                    <div className="name">
                        <input type="text" className="btn"
                            disabled={isSearching}
                            value={currentSearch}
                            onChange={e => setCurrentSearch(e.target.value)}
                            onKeyUp={e => {
                                if (e.key == "Enter") {
                                    onSearch(e.currentTarget.value)
                                }
                            }}
                            placeholder="Tryck på 'Enter' för att söka"
                        />
                    </div>
                    <div className="singleusereditor-btn">
                        <button className="btn" onClick={() => {
                            setViewState("view");
                            setCurrentUserID(userId);
                        }} >
                            <AdminIcon icon={AdminIcons.close} />
                        </button>
                        <button className="btn" onClick={() => {
                            setViewState("view");
                            onChange(currentUserID);
                        }} disabled={searchHits?.length !== 1} >
                            <AdminIcon icon={AdminIcons.save} />
                        </button>
                    </div>
                </div>
            )}

        </div>
    )
}

